import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import AsyncComponentErrorHandler from 'framework-listing-lib/internal/shared/components/AsyncComponentErrorHandler';
import CrmListingFoldersSkeleton from './CrmListingFoldersSkeleton';
import { jsx as _jsx } from "react/jsx-runtime";
export default Loadable({
  loader: () => import( /* webpackChunkName: "crm-listing-folders" */'./CrmListingFolders').then(mod => mod.default).catch(AsyncComponentErrorHandler('crm-listing-folders')),
  LoadingComponent: () => /*#__PURE__*/_jsx(CrmListingFoldersSkeleton, {})
});